import { IndexableDocument } from "./IndexableDocument";

export interface EntitySearchResponse {
	documents: IndexableDocument[];
	count: number;
	page?: number;
	pageSize?: number;
	countCapped?: boolean;
	/**
	 * LSP-16659: per-type totals, present only when the request asked for documents. Consistent with
	 * `count` / `countCapped`. Lets the page tell "photos or videos exist" from "only files exist" without
	 * loading every page — Sparky must stay disabled for a grid of non-PDF files.
	 */
	countsByEntityType?: EntitySearchCountsByEntityType;
}

export interface EntitySearchCountsByEntityType {
	snapshot: number;
	recording: number;
	document: number;
}

export const emptyEntitySearchResponse = () => ({ documents: [], count: 0 }) satisfies EntitySearchResponse;
